import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-flexbox-grid";
import Select from "react-select";
import countries from "../../fixtures/countries";
import countriesFlags from "../../assets/countries_flag";
import {
  sendVerificationSMS,
  validateVerificationCode,
  signOut,
  getUserLocation,
  track,
  haveMobileAppClear
} from "../../redux/auth/actions";
import * as selectors from "../../redux/auth/selectors";
import ActivityIndicator from "react-activity-indicator";
import escapeStringRegexp from "escape-string-regexp";

import "react-select/dist/react-select.css";
import "react-activity-indicator/src/activityindicator.css";
import logo from "../../assets/logo.png";
import apple from "../../assets/apple-icon.png";
import google from "../../assets/google-icon.png";
import "./SignUp.css";
import { isIE } from "../../utils/navigator";

import * as qs from "query-string";

const mapStateToProps = state => ({
  userId: selectors.getUserId(state),
  phone: selectors.getPhoneNumber(state),
  isSent: selectors.verificationIsFetching(state),
  success: selectors.verificationCodeSent(state),
  error: selectors.verificationCodeSendError(state),
  sendErrorMessage: selectors.verificationCodeSendErrorMessage(state),
  validationError: selectors.validationError(state),
  validationErrorMessage: selectors.validationErrorMessage(state),
  access_token: selectors.getAccessToken(state),
  id_token: selectors.getTokenId(state),
  authenticated: selectors.isAuthenticated(state),
  firebase_id_token: selectors.getFirebaseToken(state),
  location: selectors.getLocation(state),
  haveMobileApp: selectors.haveMobileApp(state),
  user: selectors.getUserProfile(state)
});

const mapDispatchToProps = {
  sendVerificationSMS,
  validateVerificationCode,
  signOut,
  getUserLocation,
  track,
  haveMobileAppClear
};

class SignUp extends Component {
  state = {
    step: 1,
    hasApp: false,
    country: {
      name: "Please select country",
      code: "+000",
      alpha2: "UNKNOWN",
      error: true,
      showError: false
    },
    phone: "",
    verificationCode: ""
  };

  constructor(props, context) {
    super(props, context);

    this.componentCleanup = this.componentCleanup.bind(this);
  }

  componentWillMount() {
    const { history } = this.props;

    const params = qs.parse(history.location.search);

    if (params) {
      if (params.redirectType) {
        this.setState({
          step: 2,
          hasApp: true
        });
      }
      // if (params.phone) {
      //   this.setState({
      //     phone: params.phone.trim()
      //   })
      // }
    }

    if (this.props.location.search === "?section=login") {
      this.setState({
        step: 2,
        hasApp: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { location, history, track } = nextProps;

    const params = qs.parse(history.location.search);

    if (nextProps.userId && nextProps.firebase_id_token) {
      if (params && params.redirectType && params.action) {
        nextProps.history.push(`/dashboard/project/${params.projectId}`, {
          action: params.action
        });
      } else {
        nextProps.history.push("/dashboard/issues");
      }
    }

    if (!nextProps.haveMobileApp) {
      this.setState({
        step: 2,
        hasApp: false,
        country: {
          ...this.state.country,
          error: true,
          showError: false
        },
        phone: "",
        verificationCode: ""
      });
    }

    if (location && location !== this.props.location) {
      this._autoDetectPhone(location);
    }
  }

  // componentDidUpdate() {
  //   if (this.props.authenticated) {
  //     this.props.history.push('/dashboard/files');
  //   }
  // }

  componentWillUnmount() {
    this.componentCleanup();
  }

  componentCleanup() {
    const { firebase_id_token, authenticated, userId, phone, user } = this.props;
    console.log('componentCleanup');
    if (phone && userId && !authenticated && !firebase_id_token && !user) {
      this.props.signOut();
    }
  }

  componentDidMount() {
    this.props.getUserLocation();
    window.addEventListener("beforeunload", this.componentCleanup);
  }

  _autoDetectPhone = location => {
    let copyCountries = countries.slice();
    copyCountries = copyCountries.filter(country => {
      return country.alpha2 === location.country;
    });

    if (copyCountries[0]) {
      this.handleCountrySelectChange(copyCountries[0]);
    }
  };

  onHaveApp = e => {
    this.props.haveMobileAppClear();
    this.handleHaveApp(e);
  };

  handleHaveApp = e => {
    e.preventDefault();
    this.setState({
      step: 2,
      hasApp: true
    });
  };

  handleHasAppClick = e => {
    this.setState({
      step: 2,
      hasApp: e.target.classList.contains("btn-primary")
    });
  };

  renderCountryOption = option => {
    return (
      <span>
        <img
          src={countriesFlags[option.alpha2]}
          width={21}
          height={14}
          alt={option.label}
        />{" "}
        {option.label} ({option.alpha2}) {option.code}
      </span>
    );
  };

  renderCountryValue = option => {
    return (
      <span>
        <img
          src={countriesFlags[option.alpha2]}
          width={21}
          height={14}
          alt={option.label}
        />
        <span className="code-value">({option.code})</span>
      </span>
    );
  };

  renderCountryPlaceholder = () => {
    return (
      <span>
        <img src={countriesFlags.UNKNOWN} width={21} height={14} />
      </span>
    );
  };

  handleCountrySelectChange = value => {
    if (value.length === 0) {
      return;
    }

    let newPhoneValue;
    if (this.state.phone !== "") {
      newPhoneValue = this.state.phone.replace(
        this.state.country.code,
        value.code
      );
    } else {
      newPhoneValue = `${value.code}${this.state.phone}`;
    }

    this.setState(
      {
        country: value,
        phone: ""
      },
      () => {
        if (this.phoneInput) {
          this.phoneInput.focus();
        }
      }
    );
  };

  handleChangePhoneNumber = event => {
    this.setState({
      phone: event.target.value
    });
  };

  handleBackButton = event => {
    this.setState({
      step: 1,
      hasApp: false
    });
  };

  handleBackToNumberButton = () => {
    this.setState(
      {
        phone: "",
        verificationCode: ""
      },
      () => {
        this.props.signOut();
      }
    );
    // ;
  };

  handleContinueLoginButton = () => {
    const countryCode = new RegExp(
      `^${escapeStringRegexp(this.state.country.code)}`
    );
    const phoneHasPlus = /\+/.test(this.state.phone);
    if (this.state.country.error && !phoneHasPlus) {
      this.setState({
        country: {
          ...this.state.country,
          showError: true
        }
      });
    } else if (countryCode.test(this.state.phone) || phoneHasPlus) {
      this.props.sendVerificationSMS(this.state.phone);
    } else {
      this.setState(
        {
          phone: `${this.state.country.code}${this.state.phone}`
        },
        () => {
          this.props.sendVerificationSMS(this.state.phone);
        }
      );
    }
  };

  handleChangeVerificationCode = event => {
    this.setState({
      verificationCode: event.target.value
    });
  };

  handleLogIn = () => {
    this.props.validateVerificationCode(
      this.props.phone,
      this.state.verificationCode
    );
  };

  _handleInputPress = event => {
    if (event.key === "Enter") {
      if (
        this.state.step === 2 &&
        !this.props.phone &&
        this.state.phone !== ""
      ) {
        this.handleContinueLoginButton();
      } else if (
        this.state.step === 2 &&
        this.props.phone.length &&
        this.state.verificationCode !== ""
      ) {
        this.handleLogIn();
      }
    }
  };

  renderCopyRight = () => {
    if (isIE()) {
      return null;
    }

    return (
      <Row center="xs" middle="xs">
        <Col xs={12} className="copy-right text-system-4">
          2017 &copy; Pulser. All Rights Reserved
        </Col>
      </Row>
    );
  };

  render() {
    const { location } = this.props;

    return (
      <Grid className="SingUpContainer" fluid>
        <Row top="xs" className={`step-${this.state.step}`}>
          <Col xs={12}>
            <Row center="xs" className="logo-wrapper">
              <Col xs={12}>
                <a href="/">
                  <img src={logo} width={150} alt="Pulser" />
                </a>
              </Col>
            </Row>
            <Row center="xs">
              <Col xs={12}>
                {this.state.step === 1 && (
                  <h1 className="text-system-1">Welcome to Pulser</h1>
                )}
                {this.state.step === 1 && (
                  <span className="text-system-2">
                    Document and manage your construction projects.
                    <br />
                    Easily search for any item of your construction projects –
                    photos, approvals, tasks, blueprints, or files
                  </span>
                )}
                {!this.props.haveMobileApp && (
                  <span className="title-no-app">
                    Sorry, seems you are not yet a Pulser member.
                  </span>
                )}
                {this.state.step === 2 &&
                  !this.state.hasApp && (
                    <span className="text-system-2 step-desciption">
                      To activate Pulser on your desktop you must first have
                      Pulser installed on your <br /> mobile device.
                    </span>
                  )}
              </Col>
            </Row>
            {this.state.step === 1 && (
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={12}>
                    <span className="text-system-3 question">
                      Do you have Pulser on your mobile phone?
                    </span>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col xs={12}>
                    <Row center="xs">
                      <Col xs={3}>
                        <button
                          className="btn btn-secondary"
                          onClick={this.handleHasAppClick}
                        >
                          No
                        </button>
                      </Col>
                      <Col xs={3}>
                        <button
                          className="btn btn-primary"
                          onClick={this.handleHasAppClick}
                        >
                          Yes
                        </button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            )}
            {this.state.step === 2 &&
              !this.state.hasApp && (
                <Col xs={12}>
                  {!this.props.haveMobileApp && (
                    <Row center="xs" className="question-block">
                      <Col xs={12}>
                        <span style={{ fontSize: "18px" }}>
                          For any question, please contact us at:
                        </span>
                        <a
                          href="mailto:asaf@beti.tech"
                          style={{ color: "#6da92e" }}
                        >
                          {" "}
                          asaf@beti.tech
                        </a>
                      </Col>
                    </Row>
                  )}
                  <Row center="xs">
                    <Col xs={12}>
                      <span className="text-system-3">
                        Pulser – Field Construction is available on:
                      </span>
                      <span className="text-system-4 available">
                        in the store you need to type: pulser – field
                        construction to find us
                      </span>
                    </Col>
                  </Row>
                  <Row center="xs">
                    <Col xs={12} sm={10} md={8} lg={8}>
                      <Row center="xs">
                        <Col xs={6} sm={5} lg={4}>
                          <Row>
                            <a
                              href="https://play.google.com/store/apps/details?id=com.pulser.android"
                              target="_blank"
                              className="btn btn-primary application-wrapper"
                            >
                              <Row middle="xs" start="xs">
                                <Col xs={3}>
                                  <img
                                    src={google}
                                    title="Pulser on Google play"
                                  />
                                </Col>
                                <Col xs>
                                  <span>Get&nbsp;in&nbsp;on</span>
                                  <br />
                                  <b>Google&nbsp;Play</b>
                                </Col>
                              </Row>
                            </a>
                          </Row>
                        </Col>
                        <Col xs={6} sm={5} lg={4}>
                          <a
                            href="https://itunes.apple.com/us/app/pulser-field-construction/id1224626487"
                            target="_blank"
                            className="btn btn-primary application-wrapper"
                          >
                            <Row middle="xs" start="xs">
                              <Col xs={3}>
                                <img src={apple} title="Pulser on App store" />
                              </Col>
                              <Col xs>
                                <span>Download&nbsp;on&nbsp;the</span>
                                <br />
                                <b>App&nbsp;Store</b>
                              </Col>
                            </Row>
                          </a>
                        </Col>
                      </Row>
                      <Row center="xs" className="link-block">
                        <Col xs={12}>
                          <a href="/" onClick={this.onHaveApp}>
                            I have Pulser on my phone
                          </a>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {this.props.haveMobileApp && (
                    <Row center="xs" className="question-block">
                      <Col xs={12}>
                        <span>For any question, please contact us at:</span>
                        <a
                          href="mailto:asaf@beti.tech"
                          style={{ color: "#6da92e" }}
                        >
                          {" "}
                          asaf@beti.tech
                        </a>
                      </Col>
                    </Row>
                  )}
                </Col>
              )}
            {this.state.step === 2 &&
              this.state.hasApp &&
              !this.props.success && (
                <Col xs={12}>
                  <Row center="xs">
                    <Col xs={12}>
                      <h1 className="text-system-1">Enter your phone number</h1>
                    </Col>
                  </Row>
                  <Row center="xs">
                    <Col xs={12} sm={8} md={6} lg={5}>
                      <Row>
                        <Select
                          clearable={false}
                          autosize={false}
                          onBlurResetsInput={false}
                          // arrowRenderer={() => null}
                          name="form-field-name"
                          options={countries}
                          valueKey="code"
                          className="col-xs-3"
                          placeholder={this.renderCountryPlaceholder}
                          onChange={this.handleCountrySelectChange}
                          value={this.state.country}
                          optionRenderer={this.renderCountryOption}
                          valueRenderer={this.renderCountryValue}
                          matchProp="any"
                        />
                        <input
                          type="tel"
                          name="phone"
                          className="phone-input col-xs-9"
                          ref={ref => (this.phoneInput = ref)}
                          value={this.state.phone}
                          onChange={this.handleChangePhoneNumber}
                          onKeyPress={this._handleInputPress}
                        />
                      </Row>
                    </Col>
                  </Row>
                  {this.props.error &&
                    !this.state.country.error && (
                      <Row center="xs" className="error-message mt-10 mb-20">
                        <Col xs={12}>{this.props.sendErrorMessage}</Col>
                      </Row>
                    )}
                  {this.state.country.showError &&
                    this.state.country.error && (
                      <Row center="xs" className="error-message mt-10 mb-20">
                        <Col xs={12}>Please select country first</Col>
                      </Row>
                    )}
                  <Row center="xs" className="number-description">
                    <Col xs={12} className="width-463 mt-10 mb-40 text-center">
                      <span className="text-system-5">
                        Your mobile number is required for activation. This
                        number will be used as your ID at Pulser.
                      </span>
                    </Col>
                  </Row>
                  <Row className="buttons-wrapper" center="xs">
                    <Col xs={12} sm={8} md={6} lg={5}>
                      <Row center="xs">
                        <Col xs={6}>
                          <button
                            className="btn btn-secondary"
                            onClick={this.handleBackButton}
                          >
                            Back
                          </button>
                        </Col>
                        <Col xs={6}>
                          <button
                            className="btn btn-primary"
                            onClick={this.handleContinueLoginButton}
                            disabled={this.state.phone === ""}
                          >
                            Continue
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )}
            {this.state.step === 2 &&
              this.props.isSent &&
              !this.props.success &&
              !this.props.error && (
                <Col xs={12}>
                  <Row center="xs">
                    <Col xs={12}>
                      <ActivityIndicator
                        number={3}
                        diameter={40}
                        borderWidth={1}
                        duration={300}
                        activeColor="#5BA22F"
                        borderColor="white"
                        borderWidth={5}
                        borderRadius="50%"
                      />
                    </Col>
                  </Row>
                </Col>
              )}
            {this.state.step === 2 &&
              !this.props.isSent &&
              this.props.success &&
              !this.props.error && (
                <Col xs={12}>
                  <Row center="xs">
                    <Col xs={12}>
                      <h1 className="text-system-1 mt-0 mb-70">
                        Pulser Security Code
                      </h1>
                    </Col>
                  </Row>
                  <Row center="xs" className="mb-20">
                    <Col xs={6} sm={4} md={3} lg={2}>
                      <input
                        type="text"
                        placeholder="XXXXXX"
                        name="verification_code"
                        className="verification-input"
                        value={this.state.verificationCode}
                        onChange={this.handleChangeVerificationCode}
                        autoFocus
                      />
                    </Col>
                  </Row>
                  {this.props.validationError && (
                    <Row
                      center="xs"
                      className="text-system-6 error-message mt-5 mb-20"
                    >
                      <Col xs={6} sm={4} md={3} lg={2}>
                        {this.props.validationErrorMessage}
                      </Col>
                    </Row>
                  )}
                  <Row center="xs">
                    <Col xs={12}>
                      <span className="text-system-6">
                        Add the SMS code you received on your{" "}
                        <span className="bold">mobile</span>
                      </span>
                    </Col>
                  </Row>
                  <Row className="buttons-wrapper mt-90" center="xs">
                    <Col xs={12} sm={8} md={6} lg={5}>
                      <Row center="xs">
                        <Col xs={6}>
                          <button
                            className="btn btn-secondary"
                            onClick={this.handleBackToNumberButton}
                          >
                            Back
                          </button>
                        </Col>
                        <Col xs={6}>
                          <button
                            className="btn btn-primary"
                            disabled={this.state.verificationCode === ""}
                            onClick={this.handleLogIn}
                          >
                            Continue
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )}
          </Col>
        </Row>
        {this.renderCopyRight()}
      </Grid>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp);
